import React from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import colors from 'common/styles/colors';
import { FlexContainer } from 'common/components/atoms';
import { formatDate } from 'common/utils';
import MetadataContainer from 'common/components/atoms/MetadataContainer';
import DeleteIconSvg from 'common/images/BearingModal/DeleteIconSvg';
import { Wrench } from 'common/images/FaIcons';
import { deleteRepair } from '../actions/repairs.actions';

import {
  TimelineNoDataContainer as NoDataContainer,
  TimelineItemContainer as TaskItemContainer,
  TimelineText as Text,
  TimelineSecondaryText as SecondaryText,
  TimelineIconContainer as IconContainer
} from './TaskDetailsModal.styled';

function RepairsTimeline({ repairs, taskId, setRepairModalOpen, deleteRepair }) {
  const { t } = useTranslation();
  const getRepairTimestamp = (repair) => {
    if (repair.created_at) return repair.created_at;
    if (repair.updated_at) return repair.updated_at;
    return repair.id || 0;
  };

  const sortedRepairs = _.orderBy(
    repairs || [],
    [getRepairTimestamp],
    ['desc']
  );

  return (
    <div style={{ marginTop: '1rem' }}>
      {_.isEmpty(sortedRepairs) ? (
        <NoDataContainer>{t('taskDetailsModal.timeline.noRepairs')}</NoDataContainer>
      ) : (
        sortedRepairs.map(repair => (
          <TaskItemContainer
            key={repair.id}
            onClick={() => setRepairModalOpen(repair.id)}
          >
            <IconContainer>
              <Wrench />
            </IconContainer>
            <FlexContainer direction="column" flexGrow={1}>
              <Text bold>{repair.name || t('taskDetailsModal.timeline.unnamedRepair')}</Text>
              <MetadataContainer fontSize="12px">
                <SecondaryText>{formatDate(getRepairTimestamp(repair))}</SecondaryText>
              </MetadataContainer>
              {repair.description && (
                <SecondaryText color={colors.black}>{repair.description}</SecondaryText>
              )}
            </FlexContainer>
            <IconContainer
              onClick={(e) => {
                e.stopPropagation();
                deleteRepair(repair.id, taskId);
              }}
              title={t('taskDetailsModal.timeline.deleteRepair')}
            >
              <DeleteIconSvg />
            </IconContainer>
          </TaskItemContainer>
        ))
      )}
    </div>
  );
}

RepairsTimeline.propTypes = {
  repairs: PropTypes.array,
  taskId: PropTypes.number.isRequired,
  setRepairModalOpen: PropTypes.func.isRequired,
  deleteRepair: PropTypes.func.isRequired
};

RepairsTimeline.defaultProps = {
  repairs: []
};

const mapDispatchToProps = dispatch => ({
  deleteRepair: bindActionCreators(deleteRepair, dispatch)
});

export default connect(null, mapDispatchToProps)(RepairsTimeline);
